module.exports = __webpack_public_path__ + "static/media/icon-numberOfStores.9e50c0a2.svg";